import { useState } from 'react';

export function useCheckbox(initialValue: boolean, name?: string) {
  const [value, setValue] = useState(initialValue);

  return {
    value,
    setValue,
    reset: () => setValue(initialValue),
    bind: {
      checked: value,
      value,
      name,
      onChange: () => {
        setValue(!value);
      },
      setValue: (val: boolean) => setValue(val),
    },
  };
}
